export const dataTypeKeys = {
  all: ["datatype"] as const,
  project: (project: string | null) => [...dataTypeKeys.all, project] as const,
  dataType: (dataTypeId: string | null) => [...dataTypeKeys.all, dataTypeId] as const,
  categorizedEntity: (dataTypeId: string | null) => [...dataTypeKeys.all, dataTypeId, "categorizedEntity"] as const,
  allData: (elementId: string, elementName: string, projectId: string) =>
    [...dataTypeKeys.all, elementId, elementName, projectId, "elementAllData"] as const,
};
